import PropTypes from 'prop-types';
import React from 'react';

var CountriesCounter = function CountriesCounter(_ref) {
  var selectedCountriesNumber = _ref.selectedCountriesNumber,
      totalCountriesNumber = _ref.totalCountriesNumber,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;
  return (
    /* eslint-disable max-len */
    React.createElement("div", {
      className: "CountriesCounter"
    }, React.createElement("span", null, selectedCountriesNumber, ' ', formatMessage(messages.countriesCounterOf), ' ', totalCountriesNumber))
    /* eslint-enable max-len */

  );
};

CountriesCounter.propTypes = {
  selectedCountriesNumber: PropTypes.number,
  totalCountriesNumber: PropTypes.number,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default CountriesCounter;